import React from 'react';
import ConfigContainer from "../containers/ConfigContainer";

const ConfigView = () => {

  return (
      <ConfigContainer/>
  );
};

export default ConfigView;
